"use client";

import { ServiceBlocks } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const ServiceOverview = () => {
  const t = useTranslations("salesOptimizedFloorPlans.serviceBlock");

  const serviceBlocks = [
    {
      step: "01",
      title: t("01.title"),
      text: t("01.text"),
    },
    {
      step: "02",
      title: t("02.title"),
      text: t("02.text"),
    },
    {
      step: "03",
      title: t("03.title"),
      text: t("03.text"),
    },
    {
      step: "04",
      title: t("04.title"),
      text: t("04.text"),
    },
    {
      step: "05",
      title: t("05.title"),
      text: t("05.text"),
    },
    {
      step: "06",
      title: t("06.title"),
      text: t("06.text"),
    },
  ];

  return <ServiceBlocks id="section-2" serviceBlocks={serviceBlocks} />;
};

export default ServiceOverview;
